import { generateReportLatestIdKey } from "../utils";
import { initializeState } from "./sdlcReportSlice";
/**
 * storeReportStateThunk - will get the current "report" object out of state and serialize it to session storage.
 * This will only happen if both parameters have values.
 * @param reportKey - key used to store report state in session storage.
 * @param latestReportId - latest report id, also saved in session storage with a key based on reportKey.
 *          Necessary for associating reports with the latest report to avoid state issues after reanalyze.
 */
export const storeReportStateThunk = (reportKey, latestReportId) => (_dispatch, getState) => {
    if (!reportKey || !latestReportId) {
        return;
    }
    const report = getState().report;
    const latestIdKey = generateReportLatestIdKey(reportKey);
    sessionStorage.setItem(reportKey, JSON.stringify(report));
    sessionStorage.setItem(latestIdKey, latestReportId);
};
/**
 * restoreReportStateThunk - will restore the "report" object to state from session storage.
 * This will only happen if both parameters have values AND if latestReportId matches the latest report id stored
 * in session.
 * @param reportKey - key used to retrieve report state from session storage.
 * @param latestReportId - latest report id to match against latest report id stored in session.
 *          Necessary for associating reports with the latest report to avoid state issues after reanalyze.
 */
export const restoreReportStateThunk = (reportKey, latestReportId) => (dispatch) => {
    if (!reportKey || !latestReportId) {
        return;
    }
    const storedData = sessionStorage.getItem(reportKey);
    const storedLatestReportId = sessionStorage.getItem(generateReportLatestIdKey(reportKey));
    if (storedData &&
        storedLatestReportId &&
        storedLatestReportId === latestReportId) {
        const restored = JSON.parse(storedData);
        dispatch(initializeState(restored));
    }
};
//# sourceMappingURL=report.js.map